<template>
  <Button link @click="exportGeoJSON"
    ><i-material-symbols-download /> GeoJSON</Button
  >
</template>
<script lang="ts" setup>
import type { GeoJsonObject } from "geojson";
import { download } from "~/lib/download";

const props = defineProps<{
  course: {
    name: string | null;
    description: string | null;
    id: string;
    checkpoints: Array<{
      id: string;
      description: string | null;
      name: string | null;
      lng: number;
      lat: number;
    }>;
  };
}>();

const filename = computed(
  () => props.course.name?.replaceAll(/\s+/g, "-") || "course"
);
async function exportGeoJSON() {
  const geojson = {
    type: "FeatureCollection",
    properties: {
      name: props.course.name,
      description: props.course.description,
      id: props.course.id,
    },
    features: compact(props.course.checkpoints).map((checkpoint) => ({
      type: "Feature",
      id: checkpoint.id,
      properties: {
        "marker-symbol": "c:ring",
        "marker-color": "FF0000",
        description: checkpoint.description,
        title: checkpoint.name,
        class: "Marker",
        folderId: null,
        "marker-rotation": null,
      },
      geometry: {
        coordinates: [checkpoint.lng, checkpoint.lat, 0, 0],
        type: "Point",
      },
    })),
  } as GeoJsonObject;

  download(
    `${filename.value}.geojson`,
    JSON.stringify(geojson, null, 2),
    "application/geo+json"
  );
}
</script>
